var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xC2\xAE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8334 0.5H7.98433C7.66355 0.5 7.21521 0.685836 6.98856 0.912311L0.340456 7.56038C-0.113485 8.01381 -0.113485 8.75723 0.340456 9.21011L5.29051 14.16C5.74343 14.6134 6.48612 14.6134 6.93972 14.1595L13.5878 7.51243C13.8143 7.28599 14.0001 6.83694 14.0001 6.51684V1.66673C14.0001 1.02517 13.4749 0.5 12.8334 0.5ZM10.4999 5.16674C9.85557 5.16674 9.3332 4.64382 9.3332 4.00001C9.3332 3.35514 9.85557 2.83328 10.4999 2.83328C11.1443 2.83328 11.6668 3.35514 11.6668 4.00001C11.6669 4.64382 11.1443 5.16674 10.4999 5.16674Z",
    fill: "#595959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.76cec1e44cebb99e92e0193d02a455c9.svg";
export { ForwardRef as ReactComponent };